const initTabs = () => {
    if (document) {
        const triggers = document.getElementsByClassName('js-tabTrigger');

        const mr_setTab = (triggerEle, changeHash = true) => {
            const contentId = triggerEle.getAttribute('data-contentid');
            const contentEle = document.getElementById(contentId);
            const contentClass = triggerEle.getAttribute('data-contentclass');

            const existingEles = document.getElementsByClassName('tab-isActive');
            if (existingEles && existingEles.length) {
                const pastEles = [];
                for (let eleIndex = 0, eleLen = existingEles.length; eleIndex < eleLen; eleIndex++) {
                    pastEles.push(existingEles[eleIndex]);
                }

                pastEles.forEach(ele => {
                    if (ele) {
                        ele.className = ele.className
                            .split('tab-isActive')
                            .join('')
                            .split('  ')
                            .join(' ');
                    }
                })
            }

            const eles = [contentEle, triggerEle];

            if (contentClass) {
                const contentClassEles = document.getElementsByClassName(contentClass);
                for (let eleIndex = 0, eleLen = contentClassEles.length; eleIndex < eleLen; eleIndex++) {
                    eles.push(contentClassEles[eleIndex]);
                }
            }

            eles.forEach(ele => {
                if (ele.className.indexOf('tab-isActive') === -1) {
                    ele.className += ' tab-isActive';
                } else {
                    ele.className = ele.className
                        .split('tab-isActive')
                        .join('')
                        .split('  ')
                        .join(' ');
                }
            });

            if (changeHash) {
                window.location.hash = contentId.replace('pane-', '');
            }
        }

        const currentHash = window.location.hash.replace('#', '');

        for (let i = 0, len = triggers.length; i < len; i++) {
            const trigger = triggers[i];
            const contentId = trigger.getAttribute('data-contentid');
            const contentEle = document.getElementById(contentId);

            if (contentEle) {
                trigger.addEventListener('click', e => {
                    e.preventDefault();

                    mr_setTab(trigger);
                });

                if (currentHash) {
                    const paneId = `pane-${currentHash}`;

                    if (contentId === paneId) {
                        mr_setTab(trigger); // tab in url directly
                    } else {
                        const hashEle = document.querySelector(`#${currentHash}.${contentId.replace('pane-', '')}`);
                        if (hashEle) {
                            mr_setTab(trigger, false); // contents of tab in url
                            window.setTimeout(() => {
                                window.scrollTo(0, hashEle.offsetTop);
                            }, 0)
                        }
                    }
                } 
            }
        }
    }
};

initTabs();
